const MAX_WIDTH = 1920;
const WEBP_QUALITY = 0.85;

/**
 * Converts an image File to WebP format client-side using canvas.
 * Resizes to MAX_WIDTH if wider. Falls back to original file if conversion fails.
 */
export async function convertToWebP(file: File): Promise<File> {
  // Skip if already WebP or not an image
  if (file.type === 'image/webp' || !file.type.startsWith('image/')) {
    return file;
  }

  return new Promise((resolve) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);

      let { width, height } = img;
      if (width > MAX_WIDTH) {
        height = Math.round((height * MAX_WIDTH) / width);
        width = MAX_WIDTH;
      }

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      if (!ctx) { resolve(file); return; }

      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob(
        (blob) => {
          if (blob) {
            const webpName = file.name.replace(/\.[^.]+$/, '.webp');
            resolve(new File([blob], webpName, { type: 'image/webp' }));
          } else {
            resolve(file); // fallback to original
          }
        },
        'image/webp',
        WEBP_QUALITY,
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(file); // fallback to original
    };

    img.src = objectUrl;
  });
}
